import { getGenericStore } from './genericStore';

const dataBusStore = Object.create(getGenericStore({ to: null, from: null, content: null }));
export default dataBusStore;